<template @drop="onDropFile" @dragover.prevent>
  <v-app>
    <div id="appBar" dark app style="padding: 0; z-index: 1000">
      <div style="display: flex; flex: 1; flex-direction: column">
        <div
          :style="
            n['style'] +
            'display: flex; flex-direction: row; width: 100%; align-items: center; justify-content: center;'
          "
          v-for="n in globalNotification"
          :key="n['id']"
        >
          <v-img
            style="width: 32px; height: 32px; flex: none"
            src="img/announcement-icon.svg"
            contain
            transition="scale-transition"
          >
          </v-img>
          <div
            v-html="
              $i18n.locale == 'zh' ? n['html_content_tc'] : n['html_content_en']
            "
          ></div>
          <v-btn icon @click.stop="setDisableNotification(n['id'])"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </div>
        <div
          style="
            display: flex;
            padding: 4px 16px;
            height: 64px;
            background-color: #183952;
            color: #fff;
            align-items: center;
          "
        >
          <div class="d-flex align-center">
            <v-img
              width="40"
              src="img/logo.png"
              contain
              transition="scale-transition"
            ></v-img>
            <!-- <span
          alt="Lands Dept Logo"
          class="shrink mr-2 logo"
          transition="scale-transition"
        /> -->

            <span class="text-xs-h7 text-sm-h6 text-md-h5">{{
              $t("common.appName")
            }}</span>
          </div>

          <v-spacer></v-spacer>
          <div>
            <template v-if="$vuetify.breakpoint.name != 'xs'">
              <ul class="appbar_menu">
                <li>
                  <SwitchLanguage
                    style="color: #fff"
                    :app="this"
                    ref="switchLanguage"
                  ></SwitchLanguage>
                </li>
                <!-- App Bar - Help Tour -->
                <li>
                  <v-btn
                    dark
                    small
                    text
                    @click.stop="map.tour2.runMapTourSteps()"
                    :title="$t('common.helpTitleTips')"
                  >
                    <v-icon>mdi-help-circle</v-icon>
                  </v-btn>
                </li>
                <!-- App Bar - About -->
                <li>
                  <!-- <About :app="this" :aboutDialog="aboutDialog"></About> -->
                  <v-btn
                    dark
                    text
                    @click.stop="
                      menuSettings = false;
                      map.aboutDialog = true;
                    "
                    class="appbar_menu_about"
                  >
                    {{ $t("common.aboutDialog.title") }}
                  </v-btn>
                </li>
              </ul>
            </template>
            <template v-else>
              <v-menu
                v-model="menuSettings"
                offset-y
                :style="`z-index: ${confirmationIndex - 2};`"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn dark icon v-bind="attrs" v-on="on">
                    <v-icon>menu</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item class="center">
                    <SwitchLanguage
                      :app="this"
                      ref="switchLanguage"
                    ></SwitchLanguage
                  ></v-list-item>
                  <v-list-item class="center">
                    <v-btn
                      text
                      @click.stop="
                        map.tour2.runMapTourSteps();
                        menuSettings = false;
                      "
                      :title="$t('common.helpTitleTips')"
                    >
                      <v-icon>mdi-help-circle</v-icon>
                    </v-btn></v-list-item
                  >
                  <v-list-item class="center">
                    <!-- <About :app="this" :aboutDialog="aboutDialog"></About> -->
                    <v-btn
                      text
                      @click.stop="
                        menuSettings = false;
                        map.aboutDialog = true;
                      "
                      class="appbar_menu_about"
                    >
                      {{ $t("common.aboutDialog.title") }}
                    </v-btn>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>

            <ul class="appbar_menu">
              <li
                v-if="
                  spaceUsed !== null &&
                  spaceUsed !== 0 &&
                  spaceRemaining !== null &&
                  spaceRemaining !== 0
                "
              >
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn x-small dark v-bind="attrs" v-on="on">{{
                      $t("common.spaceUsed") + ": " + spaceUsedPercentage
                    }}</v-btn>
                  </template>
                  {{
                    spaceUsed.toFixed(2) +
                    " / " +
                    spaceRemaining.toFixed(2) +
                    " MB"
                  }}
                </v-tooltip>
              </li>
              <!-- <li
            class="text-caption"
            v-if="savedMessage && map.enableSaveToLocalStorage"
          >
            {{ $t("common.lastSavedMessage") }} {{ savedMessage }}
          </li> -->
            </ul>
          </div>
        </div>
      </div>
    </div>

    <v-main>
      <Map
        :app="this"
        :enableLeftBarTabs="enableLeftBarTabs"
        :enableLeftBarTabsTouch="enableLeftBarTabsTouch"
        :enablePrint="enablePrint"
        :enableAttachRefLayer="enableAttachRefLayer"
        :enableAddDynamicLayer="enableAddDynamicLayer"
        :enableCurrentLocation="enableCurrentLocation"
        :rules="rules"
        :loadLocalStorageSpace="loadLocalStorageSpace"
        :showNewSnackBar="showNewSnackBar"
        :closeNewSnackBar="closeNewSnackBar"
        :showLayerMessageSnackbar="showLayerMessageSnackbar"
        :closeLayerMessageSnackbar="closeLayerMessageSnackbar"
        ref="map"
        :locate="locate"
        :indexlabelBaseMap="indexlabelBaseMap"
        :indexOverLay="indexOverLay"
        :indexDrawnItem="indexDrawnItem"
        :leftBarIndex="leftBarIndex"
        :confirmationIndex="confirmationIndex"
        :errorMessageIndex="errorMessageIndex"
        @setSavedMessage="setSavedMessage"
      />
    </v-main>

    <v-snackbar
      v-model="foreverSnackbar"
      timeout="-1"
      :style="`z-index: ${confirmationIndex - 1};`"
    >
      {{ foreverSnackbarMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          color="red"
          v-bind="attrs"
          v-if="foreverSnackbarClose"
          @click="foreverSnackbarClose"
          >{{ $t("common.finish") }}</v-btn
        >
      </template>
    </v-snackbar>

    <v-snackbars
      :style="`z-index: ${confirmationIndex + 1};`"
      :messages.sync="snackBarMessages"
      color="black"
      bottom
      right
    >
      <template v-slot:default="{ message }">
        {{ message }}
      </template>
      <!-- <template v-slot:action="{ close, index, message, id }"> -->
      <template v-slot:action="{ close }">
        <v-btn :title="$t('common.title_close')" text @click="close()">{{
          $t("common.close")
        }}</v-btn>
      </template>
    </v-snackbars>
  </v-app>
</template>

<!--<script src="https://cdnjs.cloudflare.com/ajax/libs/localforage/1.9.0/localforage.js" integrity="sha512-JrJyNknk6qY0sNOPg9LsktBNM+6J4dukn3u1mX2tEY8+BvO+vLCpASMt21HPrn30Ow08wbafPnKoMyrQ5tovJA==" crossorigin="anonymous"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/localforage/1.9.0/localforage.nopromises.js" integrity="sha512-6iVcOzkOjTvAarbGltoHmqVqQSoANV2Kna94tck59fHbqgIcEd0ZIC58kErbdEdv+uNCw4Vt/ZUg/aESNsiyOQ==" crossorigin="anonymous"></script>-->

<script>
window.onbeforeunload = function () {
  return "Do you really want to close?";
};

import Map from "./components/Map";
import VSnackbars from "v-snackbars";
import * as GLOBAL from "./components/Global";
import SwitchLanguage from "./components/SwitchLanguage.vue";
import firebase from "firebase/app";
import "firebase/analytics";
import localforage from "localforage";

import GlobalNotifications from "./globalNotifications";

export default {
  name: "App",

  components: {
    Map,
    "v-snackbars": VSnackbars,
    SwitchLanguage,
  },

  mounted() {
    this.reloadNotification();

    this.map = this.$refs.map;

    // Your web app's Firebase configuration
    // For Firebase JS SDK v7.20.0 and later, measurementId is optional
    const firebaseConfig =
      process.env.NODE_ENV === "production"
        ? {
            apiKey: "AIzaSyBpcBBQ0O7zAuBEpCgowWqSicSyVTbv7KU",
            authDomain: "geotagging-prod-dce59.firebaseapp.com",
            projectId: "geotagging-prod-dce59",
            storageBucket: "geotagging-prod-dce59.appspot.com",
            messagingSenderId: "1081894325554",
            appId: "1:1081894325554:web:79ff4c4a7238c3a97e1b2b",
            measurementId: "G-6XXNLFNHMW",
          }
        : {
            apiKey: "AIzaSyDJ1tuX5aEPN4fbItqgdTLI6dRjWF3Tnzs",
            authDomain: "geotagging-7dfe6.firebaseapp.com",
            databaseURL: "https://geotagging-7dfe6.firebaseio.com",
            projectId: "geotagging-7dfe6",
            storageBucket: "geotagging-7dfe6.appspot.com",
            messagingSenderId: "702651116650",
            appId: "1:702651116650:web:a41400f137e3ff49002e13",
            measurementId: "G-MZ0VXFJK49",
          };
    // Initialize Firebase
    firebase.initializeApp(firebaseConfig);

    this.$GA.init(firebase);
    // this.loadLocalStorageSpace();

    this.urlParamsHandler();
  },

  computed: {},

  data() {
    return {
      globalNotification: [],

      menuSettings: false,

      //enable functions
      enablePrint: false,
      enableCurrentLocation: false,
      enableAddDynamicLayer: false, //enable add user dynamic layers feature
      enableAttachRefLayer: false, //enable table item reference layers feature
      enableIdentifyResultLayer: false, //show identify result layers feature
      enableLeftBarTabs: false, //show left bar tabs feature
      enableLeftBarTabsTouch: false, //enable left bar tabs swipe for mobile

      locate: window.localStorage.getItem(GLOBAL.LOCALE_KEY),
      GLOBAL: GLOBAL,

      foreverSnackbar: false,
      foreverSnackbarMessage: "",
      foreverSnackbarClose: null,

      snackBarMessages: [],

      savedMessage: "",

      spaceRemaining: 0,
      spaceUsed: 0,
      spaceUsedPercentage: "",

      indexlabelBaseMap: 100,
      indexOverLay: 500,
      indexDrawnItem: 1000,

      leftBarIndex: 2000,
      confirmationIndex: 3000,
      errorMessageIndex: 5000,

      //Dialog
      notifications: false,
      sound: false,
      widgets: false,

      //Rules
      rules: {
        required: (value) => !!value || this.$t("common.required"),
        newColumnNameRequired: (value) =>
          !!value || this.$t("common.newColumnNameRequired"),
      },

      map: null,
    };
  },

  methods: {
    async reloadNotification() {
      let filteredGlobalNotification = [];
      for (let i = 0; i < GlobalNotifications.length; i++) {
        let g = GlobalNotifications[i];
        const result = await sessionStorage.getItem("notification:" + g.id);
        if (result) {
          continue;
        } else {
          filteredGlobalNotification.push(g);
        }
      }

      this.globalNotification = filteredGlobalNotification;
    },

    async setDisableNotification(notificationId) {
      await sessionStorage.setItem("notification:" + notificationId, true);
      await this.reloadNotification();
      this.map.resizeElements();
    },

    showLayerMessageSnackbar(message, closeFunction) {
      this.foreverSnackbarMessage = message;
      this.foreverSnackbar = true;
      this.foreverSnackbarClose = closeFunction;
    },

    closeLayerMessageSnackbar() {
      this.foreverSnackbar = false;
      this.foreverSnackbarMessage = "";
      this.foreverSnackbarClose = null;
    },

    setSavedMessage(val) {
      this.savedMessage = val;
    },

    urlParamsHandler() {
      if (this.$route.query.l && this.$route.query.l != this.locate) {
        // geodatastore redirect link
        if (this.$route.query.l == "zh-Hant-HK") {
          this.$refs.switchLanguage.chgLocate(this.GLOBAL.LANG.ZH);
        } else if (this.GLOBAL.LANG[(this.$route.query.l + "").toUpperCase()]) {
          this.$refs.switchLanguage.chgLocate(this.$route.query.l);
        }
      }

      let query = Object.assign({}, this.$route.query);
      delete query.l;
      this.$router.replace({ query }).catch((error) => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
    },

    closeNewSnackBar(message) {
      for (let i = 0; i < this.snackBarMessages.length; i++) {
        if (message == this.snackBarMessages[i]) {
          this.snackBarMessages.splice(i, 1);
        }
      }
    },

    showNewSnackBar(message) {
      if (this.snackBarMessages.length == 0) {
        this.snackBarMessages.push(message);
        return;
      }

      for (let i = 0; i < this.snackBarMessages.length; i++) {
        if (this.snackBarMessages[i] == message) {
          return;
        }
      }

      this.snackBarMessages.push(message);
    },

    async loadLocalStorageSpace() {
      // console.log("loadLocalStorageSpace")
      let data = "",
        currentDriver = localforage.driver();

      if (currentDriver == localforage.LOCALSTORAGE) {
        for (let key in window.localStorage) {
          if (Object.prototype.hasOwnProperty.call(window.localStorage, key)) {
            data += window.localStorage[key];
          }
        }

        // console.log("LOCALSTORAGE")

        this.spaceUsed = data ? (data.length * 16) / (8 * 1024) : 0;
        this.spaceRemaining = 5120;
      } else if (currentDriver == localforage.INDEXEDDB) {
        //new chrome
        if ("storage" in navigator && "estimate" in navigator.storage) {
          let result = await navigator.storage.estimate();
          this.spaceUsed = result.usage / (1024 * 1024);
          this.spaceRemaining = result.quota / (1024 * 1024);

          //old chrome
        } else if (
          "webkitTemporaryStorage" in navigator &&
          "queryUsageAndQuota" in navigator.webkitTemporaryStorage
        ) {
          navigator.webkitTemporaryStorage.queryUsageAndQuota(
            (_used, _quota) => {
              this.spaceUsed = _used / (1024 * 1024);
              this.spaceRemaining = _quota / (1024 * 1024);
            }
          );
        } else {
          // console.log("INDEXEDDB")

          data += (await localforage.getItem("dynamicFields")) + "";
          data += (await localforage.getItem("enableSaveToLocalStorage")) + "";
          data += (await localforage.getItem("tableItems")) + "";
          data += (await localforage.getItem("dynamicLayers")) + "";

          // console.log(data)

          this.spaceUsed = data ? (data.length * 16) / (8 * 1024) : 0;
          this.spaceRemaining = 256;
        }
      }

      if (this.spaceUsed != null && this.spaceRemaining != null) {
        this.spaceUsedPercentage =
          ((this.spaceUsed / this.spaceRemaining) * 100).toFixed(2) + "%";
      }
    },
  },
};
</script>
